import globals from '../../../../globals/communityGlobals';
import { updateOutcomeCodeStatus, createOutcomeCode } from '../../../../actions/areas/admin/commandActions';

const locale = globals.getAreas(['externalProvider', 'error', 'userActions']);

export const eventHandlers = (state, setState, setServerErrorMsg, auth) => {
  const handleSidePanel = isOpen => {
    setState(newState => ({ ...newState, openAddCodePanel: isOpen }));
  };
  const onClose = () => {
    handleSidePanel(false);
    setServerErrorMsg('');
  };

  const refreshTable = () => {
    setState(newState => ({ ...newState, forceReload: !state.forceReload }));
    onClose();
  };

  const displayErrorMsgInSidePanel = response => {
    setServerErrorMsg(response.message);
    handleSidePanel(true);
  };

  return {
    locale,
    addButtonText: locale.getMsg('addButtonText'),
    refreshTable,
    handleSidePanel,
    onClose,
    updateOutcomeCodeStatus: (id, isActive) => updateOutcomeCodeStatus(auth, { id, isActive }, refreshTable),
    createOutcomeCode: name => {
      createOutcomeCode(auth, { name }, refreshTable, displayErrorMsgInSidePanel);
    },
  };
};
